import axios from 'axios';
import { PROCESS_AUTOMATION_SERVICE_URL } from '../Common/Constant/API';
import { commonRequestHeaders } from '../Common/request/headers';

export const login = async (loginDTO) => {
  try {
    const response = await axios.post(`${PROCESS_AUTOMATION_SERVICE_URL}/auth/login`, loginDTO, {
      headers: commonRequestHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error during login:', error);
    throw error;
  }
};
